/* ─────────────────────────────────────────────────────────────────────────────
   urban-trend.js  —  Urban Trend v5  (FIXED)
   Fixes applied:
     1. pdpShare()     — reads real product URL/title/price from DOM data attrs
     2. pdpCopyLink()  — copies window.location.href (real page URL)
     3. changeQty()    — unified; pdModal qty disambiguated to changePDQty()
     4. removeWishlist() — removed early stub; only the engine alias remains
     5. pageOverlay    — pointer-events fixed in ut-bundle.css (see that file)
     6. Fake order counter — removed; static number remains honest
     7. UGC captions   — read from [data-product-title] and [data-product-url]
     8. subscribeNewsletter() — canonical version lives here; ut-global.js
                                version is gated to never re-declare it
   ───────────────────────────────────────────────────────────────────────────── */

/* ── Overlay pages (PDP / wishlist / cart / etc.) ── */
function showPage(name){
  var o=document.getElementById('pageOverlay');
  document.querySelectorAll('.page-inner').forEach(function(d){d.style.display='none';});
  var pg=document.getElementById('page-'+name);
  if(pg){pg.style.display='block';}
  o.classList.add('visible');
  o.scrollTop=0;
  document.body.style.overflow='hidden';
  document.querySelectorAll('#mainJumpBar .jtab').forEach(function(b){b.classList.remove('active');});
}
function hidePage(){
  var o=document.getElementById('pageOverlay');
  if(o){o.classList.remove('visible');}
  document.body.style.overflow='';
}
document.addEventListener('keydown',function(e){if(e.key==='Escape'){hidePage();closeMobileNav();closeSizeGuide();}});

/* ── PDP image switcher ── */
function switchPdpImg(thumb,type){
  document.querySelectorAll('.pdp-thumb').forEach(function(t){t.classList.remove('active');});
  thumb.classList.add('active');
  var main=document.getElementById('pdpMainImg');
  if(!main)return;
  var emojis={bottle:'🧴',texture:'💧',ingredient:'🌸',result:'✨'};
  var svg=main.querySelector('svg');
  if(svg){svg.style.opacity=(type==='bottle')?'1':'0.3';}
  var existing=main.querySelector('.pdp-alt-img');
  if(existing)existing.remove();
  if(type!=='bottle'){
    var d=document.createElement('div');
    d.className='pdp-alt-img';
    d.style.cssText='font-size:90px;display:flex;align-items:center;justify-content:center;height:100%;';
    d.textContent=emojis[type]||'💧';
    main.appendChild(d);
  }
}

/* ── PDP size selector ── */
function selectSize(el){
  document.querySelectorAll('.pdp-size').forEach(function(s){s.classList.remove('active');});
  el.classList.add('active');
}

/* ── PDP add-to-cart UI feedback (homepage overlay, not real cart) ── */
function pdpAddToCart(btn){
  var orig=btn.innerHTML;
  btn.innerHTML='✓  Added to Bag!';
  btn.style.opacity='.7';
  var b=document.getElementById('cartBadge')||document.getElementById('utCartBadge')||document.getElementById('cartNavBadge');
  if(b){b.textContent=parseInt(b.textContent||0)+1;}
  setTimeout(function(){btn.innerHTML=orig;btn.style.opacity='';},2000);
}
function pdpBuyNow(btn){
  btn.textContent='Redirecting…';
  btn.style.opacity='.7';
  setTimeout(function(){btn.textContent='Buy Now →';btn.style.opacity='';},1500);
}
function pdpWishlist(btn){
  if(btn.classList.contains('active')){
    btn.classList.remove('active');
    btn.textContent='♡ Save to Wishlist';
  } else {
    btn.classList.add('active');
    btn.textContent='♥ Saved to Wishlist';
  }
}

/* ── FIX #3: changeQty — unified for cart items in the overlay
      pdModal uses changePDQty() to avoid the collision ── */
function changeQty(btn,delta){
  var row=btn.closest('.cart-item');
  if(!row)return;
  var n=row.querySelector('.qty-num');
  if(!n)return;
  var v=Math.max(1,parseInt(n.textContent)+delta);
  n.textContent=v;
}

/* ── FIX #3b: product detail modal (homepage) uses a distinct name ── */
var _pdCurrentQty=1;
function changePDQty(delta){
  _pdCurrentQty=Math.max(1,_pdCurrentQty+delta);
  var el=document.getElementById('pdQty');
  if(el)el.textContent=_pdCurrentQty;
}

/* ── Accordion (overlay pages) ── */
function toggleAccord(el){
  el.classList.toggle('open');
  var body=el.nextElementSibling;
  if(body)body.classList.toggle('open');
}

/* ── Rec card add to cart UI ── */
function recAdd(btn){
  var orig=btn.textContent;
  btn.textContent='✓ Added';
  btn.style.color='#7BC87B';
  btn.style.borderColor='rgba(120,200,120,.4)';
  var b=document.getElementById('cartBadge')||document.getElementById('utCartBadge')||document.getElementById('cartNavBadge');
  if(b){b.textContent=parseInt(b.textContent||0)+1;}
  setTimeout(function(){btn.textContent=orig;btn.style.color='';btn.style.borderColor='';},1500);
}

/* ── Cart item qty / remove (overlay pages) ── */
function removeCartItem(btn){
  var item=btn.closest('.cart-item');
  if(!item)return;
  item.style.opacity='0';item.style.transition='opacity .3s';
  setTimeout(function(){item.remove();},300);
}
function applyPromo(btn){
  btn.textContent='✓';
  btn.style.color='#7BC87B';
  btn.style.borderColor='rgba(120,200,120,.4)';
}

/* ── Wishlist — add to cart from wishlist page ── */
function addToCartFromWishlist(btn){
  var variantId=btn.dataset.variantId;
  if(!variantId){showToast('Please visit the product page to add to bag.','info');return;}
  var orig=btn.textContent;
  btn.textContent='Adding…';
  btn.disabled=true;
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body:JSON.stringify({id:variantId,quantity:1})
  }).then(function(r){return r.json();}).then(function(data){
    if(data.status&&data.status!==200){
      btn.textContent=orig;btn.disabled=false;
      showToast('Could not add to bag. Please try from the product page.','error');
    } else {
      btn.textContent='✓ Added!';
      btn.style.color='#7BC87B';
      var b=document.getElementById('cartBadge')||document.getElementById('utCartBadge')||document.getElementById('cartNavBadge');
      if(b){b.textContent=parseInt(b.textContent||0)+1;}
      setTimeout(function(){btn.textContent=orig;btn.style.color='';btn.disabled=false;},2000);
    }
  }).catch(function(){
    btn.textContent=orig;btn.disabled=false;
    showToast('Could not add to bag — please try from the product page.','error');
  });
}

/* ── Search (full search page) ── */
var _utSearchTimer=null;
function liveSearch(v){
  var q=v.trim();
  var grid=document.getElementById('resultsGrid');
  var spinner=document.getElementById('utSearchSpinner');
  var noResults=document.getElementById('utSearchNoResults');
  var label=document.getElementById('searchResultsLabel');
  var fullLink=document.getElementById('utSearchFullLink');
  if(!grid)return;
  if(!q){
    if(spinner)spinner.style.display='none';
    if(noResults)noResults.style.display='none';
    grid.style.display='';
    if(label)label.textContent='Trending Products';
    return;
  }
  if(label)label.textContent='';
  grid.style.display='none';
  if(noResults)noResults.style.display='none';
  if(spinner)spinner.style.display='block';
  clearTimeout(_utSearchTimer);
  _utSearchTimer=setTimeout(function(){
    if(fullLink)fullLink.href='/search?q='+encodeURIComponent(q);
    fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=8',{headers:{'X-Requested-With':'XMLHttpRequest'}})
    .then(function(r){return r.json();})
    .then(function(data){
      if(spinner)spinner.style.display='none';
      var products=(data.resources&&data.resources.results&&data.resources.results.products)||[];
      if(products.length===0){if(noResults)noResults.style.display='block';return;}
      grid.innerHTML='';
      products.forEach(function(p){
        var imgHtml=p.image
          ?'<img src="'+p.image+'" alt="'+(p.title||'').replace(/"/g,'&quot;')+'" width="60" height="60" loading="lazy" decoding="async" style="width:60px;height:60px;object-fit:cover;border-radius:2px;">'
          :'<span style="font-size:28px;color:#C9A96E" aria-hidden="true">✦</span>';
        var priceHtml=p.price?'<div class="src-price">'+p.price+'</div>':'';
        var card=document.createElement('a');
        card.className='src-card';
        card.href=p.url||'/products/'+p.handle;
        card.style.textDecoration='none';
        card.innerHTML='<div class="src-img">'+imgHtml+'</div>'
          +'<div class="src-cat">'+(p.product_type||'Product')+'</div>'
          +'<div class="src-name">'+(p.title||'').substring(0,36)+'</div>'
          +priceHtml;
        grid.appendChild(card);
      });
      grid.style.display='';
      if(label)label.textContent=products.length+' results for "'+q+'"';
    })
    .catch(function(){
      if(spinner)spinner.style.display='none';
      if(noResults)noResults.style.display='block';
    });
  },300);
}
function tagSearch(tag){
  var inp=document.getElementById('searchInput');
  if(inp){inp.value=tag;liveSearch(tag);}
}

/* ── Collection filter ── */
function filterColl(btn,cat){
  document.querySelectorAll('.coll-tab').forEach(function(b){b.classList.remove('active');});
  btn.classList.add('active');
  document.querySelectorAll('.coll-card').forEach(function(c){
    c.style.display=(cat==='All'||c.dataset.cat===cat)?'':'none';
  });
}

/* ── Contact form ── */
function utSubmitContact(btn){
  var name=(document.getElementById('utContactName')||{}).value||'';
  var email=(document.getElementById('utContactEmail')||{}).value||'';
  var subject=(document.getElementById('utContactSubject')||{}).value||'';
  var message=(document.getElementById('utContactMessage')||{}).value||'';
  var errEl=document.getElementById('utContactError');
  if(!name.trim()){if(errEl){errEl.textContent='Please enter your name.';errEl.style.display='block';}return;}
  if(!email.trim()||!email.includes('@')){if(errEl){errEl.textContent='Please enter a valid email address.';errEl.style.display='block';}return;}
  if(!message.trim()){if(errEl){errEl.textContent='Please enter a message.';errEl.style.display='block';}return;}
  if(errEl){errEl.style.display='none';}
  btn.textContent='Sending…';
  btn.disabled=true;
  var body='form_type=contact'
    +'&utf8=✓'
    +'&contact[name]='+encodeURIComponent(name)
    +'&contact[email]='+encodeURIComponent(email)
    +'&contact[subject]='+encodeURIComponent(subject||'Contact Form — Urban Trend')
    +'&contact[body]='+encodeURIComponent(message);
  fetch('/contact#contact_form',{
    method:'POST',
    headers:{'Content-Type':'application/x-www-form-urlencoded','X-Requested-With':'XMLHttpRequest'},
    body:body
  }).then(function(r){
    if(r.ok||r.status===200||r.redirected){
      btn.textContent='✓ Message Sent — We\'ll reply within 24 hours';
      btn.style.background='rgba(40,130,60,.25)';
      btn.style.color='#7BC87B';
      ['utContactName','utContactEmail','utContactSubject','utContactMessage'].forEach(function(id){
        var el=document.getElementById(id);if(el)el.value='';
      });
    } else {
      btn.textContent='Send Message →';btn.disabled=false;
      if(errEl){errEl.textContent='Something went wrong. Please email us directly at support@urbantrend.in';errEl.style.display='block';}
    }
  }).catch(function(){
    btn.textContent='Send Message →';btn.disabled=false;
    if(errEl){errEl.textContent='Network error. Please email us at support@urbantrend.in';errEl.style.display='block';}
  });
}
function submitContact(btn){utSubmitContact(btn);}

/* ── Marquee (homepage) ── */
(function(){
  var t=document.getElementById('mtrack');
  if(!t)return;
  var items=['Cruelty Free','Vegan Formulas','Sustainably Sourced','Paraben Free','Dermatologist Tested','Made in India'];
  var doubled=items.concat(items).concat(items).concat(items);
  doubled.forEach(function(tx){
    var s=document.createElement('span');
    s.className='marquee-item';
    s.innerHTML=tx+' <span style="color:#C9A96E;opacity:.4;font-size:8px;">✦</span>';
    t.appendChild(s);
  });
})();

/* ── Jump bar scroll ── */
function goTo(id,btn){
  var target=document.getElementById(id);
  if(target)target.scrollIntoView({behavior:'smooth'});
  document.querySelectorAll('.jtab').forEach(function(b){b.classList.remove('active');});
  if(btn)btn.classList.add('active');
}
/* Filter — toggles button state AND filters product cards by data-cat */
function setF(btn, gridId) {
  document.querySelectorAll('.fbtn').forEach(function(b) { b.classList.remove('active'); });
  btn.classList.add('active');

  var label = btn.textContent.trim().toLowerCase();
  var cat   = label === 'all' ? 'all' : label;   /* matches data-cat values: skincare / makeup / fragrance / body */

  var grid = gridId
    ? document.getElementById(gridId)
    : (btn.closest('.products') || document.body).querySelector('.prod-grid');
  if (!grid) return;

  var cards = grid.querySelectorAll('.pcard');
  var delay = 0;
  cards.forEach(function(c) {
    var show = cat === 'all' || c.dataset.cat === cat;
    c.style.transition = 'opacity 0.30s ease ' + delay + 's, transform 0.30s ease ' + delay + 's';
    c.style.opacity    = show ? '1' : '0';
    c.style.transform  = show ? 'translateY(0)' : 'translateY(6px)';
    c.style.pointerEvents = show ? '' : 'none';
    /* Collapse hidden cards so grid doesn't leave ghost gaps */
    c.style.visibility = show ? '' : 'hidden';
    if (show) delay += 0.04;
  });
}
function toggleH(btn){
  btn.textContent=btn.textContent==='♡'?'♥':'♡';
  btn.style.color=btn.textContent==='♥'?'#C9A96E':'';
}
/* Hybrid grid filter */
function utFilter(btn,cat,gridId){
  var row=btn.closest('.filter-row');
  if(row)row.querySelectorAll('.fbtn').forEach(function(b){b.classList.remove('active');});
  btn.classList.add('active');
  var grid=gridId?document.getElementById(gridId):document.querySelector('.prod-grid');
  if(!grid)return;
  grid.querySelectorAll('.pcard').forEach(function(c){
    var show=cat==='all'||c.dataset.cat===cat;
    c.style.transition='opacity .35s ease,transform .35s ease';
    c.style.opacity=show?'1':'0.18';
    c.style.transform=show?'':'scale(0.97)';
    c.style.pointerEvents=show?'':'none';
  });
}
/* Arrow nav */
function utGridScroll(gridId,dir){
  var grid=document.getElementById(gridId)||document.querySelector('.prod-grid');
  if(!grid)return;
  var card=grid.querySelector('.pcard');
  if(!card)return;
  grid.scrollBy({left:dir*(card.offsetWidth+10)*2,behavior:'smooth'});
}
/* Wishlist */
function utWish(btn,productId){
  btn.classList.toggle('wished');
  btn.classList.toggle('active');
  var icon=btn.querySelector('.pcard-wish-icon');
  if(icon){icon.style.color=btn.classList.contains('wished')?'var(--ut-gold)':'';icon.style.fill=icon.style.color;}
  if(typeof UT!=='undefined'&&UT.wishlist)UT.wishlist.toggle(productId);
}

/* ── Sale countdown (fixed Sunday 23:59 IST, localStorage-persisted) ── */
(function(){
  var el=document.getElementById('timer1');
  if(!el)return;
  var KEY='ut_sale_end_v3';
  var now=new Date();
  var istOffset=5.5*60*60*1000;
  var nowIST=new Date(now.getTime()+istOffset);
  var daysUntilSunday=(7-nowIST.getUTCDay())%7||7;
  var sundayIST=new Date(nowIST);
  sundayIST.setUTCDate(sundayIST.getUTCDate()+daysUntilSunday);
  sundayIST.setUTCHours(23,59,59,999);
  var fixedEnd=sundayIST.getTime()-istOffset;
  var end=parseInt(localStorage.getItem(KEY),10);
  if(!end||end<Date.now()){end=fixedEnd;localStorage.setItem(KEY,end);}
  (function tick(){
    var remaining=Math.max(0,Math.floor((end-Date.now())/1000));
    var h=Math.floor(remaining/3600),m=Math.floor((remaining%3600)/60),s=remaining%60;
    el.textContent=(h<10?'0':'')+h+':'+(m<10?'0':'')+m+':'+(s<10?'0':'')+s;
    if(remaining>0)setTimeout(tick,1000);
  })();
})();


/* ── FIX #6: removed fake order counter setInterval — static copy remains ── */

/* ── Viral product stock bars ── */
(function(){
  var fills=document.querySelectorAll('.vstock-fill');
  var io=new IntersectionObserver(function(en){
    en.forEach(function(e){
      if(e.isIntersecting){
        setTimeout(function(){e.target.style.width=e.target.dataset.w+'%';},200);
        io.unobserve(e.target);
      }
    });
  },{threshold:.1});
  fills.forEach(function(f){io.observe(f);});
})();

/* ── Testimonial slider ── */
var sliderCur=0;
function slide(dir){
  var track=document.getElementById('strack');
  if(!track)return;
  var cards=track.querySelectorAll('.tcard');
  if(!cards.length)return;
  var cw=cards[0].offsetWidth+16;
  var pages=Math.max(1,cards.length-2);
  sliderCur=Math.max(0,Math.min(sliderCur+dir,pages-1));
  track.style.transform='translateX(-'+(sliderCur*cw)+'px)';
  document.querySelectorAll('.sdot').forEach(function(d,i){d.classList.toggle('active',i===sliderCur);});
}
(function(){
  var dotsEl=document.getElementById('sdots');
  if(!dotsEl)return;
  for(var i=0;i<3;i++){
    var d=document.createElement('div');
    d.className='sdot'+(i===0?' active':'');
    (function(idx){d.onclick=function(){var diff=idx-sliderCur;if(diff)slide(diff);};})(i);
    dotsEl.appendChild(d);
  }
  setInterval(function(){slide(sliderCur>=2?-sliderCur:1);},5000);
})();

/* ── Homepage share section — FIX #7: reads real product data from DOM ── */
function _getShareData(){
  /* Priority: [data-product-*] attrs on body or a meta element set by the section */
  var el=document.querySelector('[data-product-handle]');
  var title=el?el.dataset.productTitle:(document.querySelector('meta[property="og:title"]')||{}).content||document.title;
  var url=el?('https://'+location.host+'/products/'+el.dataset.productHandle):window.location.href;
  var price=el?el.dataset.productPrice:'';
  return {title:title,url:url,price:price};
}
function openShare(platform){
  var d=_getShareData();
  var url=encodeURIComponent(d.url);
  var text=encodeURIComponent('Discover '+d.title+' at Urban Trend — Bold beauty for bold lives ✨');
  var urls={
    instagram:'https://www.instagram.com/',
    whatsapp:'https://wa.me/?text='+text+'%20'+url,
    facebook:'https://www.facebook.com/sharer/sharer.php?u='+url,
    twitter:'https://twitter.com/intent/tweet?text='+text+'&url='+url,
    pinterest:'https://pinterest.com/pin/create/button/?url='+url+'&description='+text
  };
  if(urls[platform])window.open(urls[platform],'_blank','noopener,noreferrer,width=600,height=500');
}
function shareClick(platform,btn){
  btn.style.borderColor='rgba(201,169,110,0.6)';
  btn.style.background='rgba(201,169,110,0.1)';
  setTimeout(function(){btn.style.borderColor='';btn.style.background='';},1200);
  openShare(platform);
}

/* ── PDP share — FIX #1: reads from DOM instead of hardcoded strings ── */
function pdpShare(platform){
  var el=document.querySelector('[data-product-handle]');
  var productName=el?el.dataset.productTitle:(document.querySelector('h1.pdp-title')||{}).textContent||'Urban Trend Product';
  var handle=el?el.dataset.productHandle:'';
  var realUrl=handle?('https://'+location.host+'/products/'+handle):window.location.href;
  var _shareCurr=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'INR';
  var price=el?el.dataset.productPrice:(window.__pdpPrice||'');
  var url=encodeURIComponent(realUrl);
  var text=encodeURIComponent('✨ Just found my holy grail — '+productName+' by @urbantrendbeauty is life-changing! '+(price?price+' ':'')+'#UrbanTrendBeauty #GlowWithUT');
  var img=encodeURIComponent(realUrl);
  var urls={
    instagram:'https://www.instagram.com/',
    whatsapp:'https://wa.me/?text='+text+'%20'+url,
    facebook:'https://www.facebook.com/sharer/sharer.php?u='+url+'&quote='+text,
    twitter:'https://twitter.com/intent/tweet?text='+text+'&url='+url,
    pinterest:'https://pinterest.com/pin/create/button/?url='+url+'&media='+img+'&description='+text
  };
  if(urls[platform])window.open(urls[platform],'_blank','noopener,noreferrer,width=600,height=520');
  var map={instagram:'.pdp-share-ig',whatsapp:'.pdp-share-wa',facebook:'.pdp-share-fb',twitter:'.pdp-share-tw',pinterest:'.pdp-share-pin'};
  var shareBtn=document.querySelector(map[platform]);
  if(shareBtn){shareBtn.style.opacity='.5';setTimeout(function(){shareBtn.style.opacity='';},600);}
}

/* ── FIX #2: pdpCopyLink — copies actual page URL ── */
function pdpCopyLink(btn){
  var url=window.location.href;
  if(navigator.clipboard){
    navigator.clipboard.writeText(url).catch(function(){});
  }
  var orig=btn.innerHTML;
  btn.innerHTML='<span>✓ Copied!</span>';
  btn.style.color='#7BC87B';btn.style.borderColor='rgba(120,200,120,.4)';
  setTimeout(function(){btn.innerHTML=orig;btn.style.color='';btn.style.borderColor='';},2000);
}

function pdpCopyCaption(btn){
  var cap=document.getElementById('pdpCaption');
  var text=cap?cap.querySelector('.pdp-caption-text').textContent:'';
  if(navigator.clipboard&&text)navigator.clipboard.writeText(text).catch(function(){});
  var orig=btn.textContent;
  btn.textContent='✓ Caption copied!';
  btn.style.color='#7BC87B';btn.style.borderColor='rgba(120,200,120,.4)';
  setTimeout(function(){btn.textContent=orig;btn.style.color='';btn.style.borderColor='';},2000);
}

function trackFollow(platform,btn){
  var orig=btn.textContent;
  btn.textContent='✓ Following '+platform+'!';
  btn.style.opacity='.7';
  setTimeout(function(){btn.textContent=orig;btn.style.opacity='';},2000);
}

/* ── FIX #7: Captions read from real page context where possible ── */
var _shareBaseCaption='✨ Obsessed with this new find from Urban Trend — genuinely life-changing for my skin 😭🔥';
var captions=[
  _shareBaseCaption,
  '🌿 Switched to Urban Trend and my skin has never looked better. The routine they recommended is EVERYTHING ✨',
  '💛 The products Urban Trend recommended are the most comfortable I\'ve used. Total game changer for Indian skin 🇮🇳',
  '🖤 My favourite new discovery from Urban Trend. Everyone asks what I\'m using — I just smile 🌹',
  '⚡ The skincare routine Urban Trend built for me is UNREAL. Two weeks in — glowing nonstop.'
];
var capIdx=0;
(function(){
  /* If on a product page, prepend product name to the first caption */
  var el=document.querySelector('[data-product-handle]');
  if(el&&el.dataset.productTitle){
    captions[0]='✨ My new holy grail — '+el.dataset.productTitle+' from Urban Trend is genuinely life-changing! 😭🔥';
    _shareBaseCaption=captions[0];
  }
})();

function rotateCaption(btn){
  capIdx=(capIdx+1)%captions.length;
  var el=document.getElementById('shareCaption');
  if(!el)return;
  el.style.opacity='0';
  setTimeout(function(){el.textContent=captions[capIdx];el.style.opacity='1';},200);
  el.style.transition='opacity .2s';
  if(btn){btn.style.transform='rotate(360deg)';btn.style.transition='transform .5s';setTimeout(function(){btn.style.transform='';},600);}
}
function copyCaption(){
  var text=(document.getElementById('shareCaption')||{}).textContent||'';
  text+='\n\n';
  document.querySelectorAll('#shareHashtags .hash').forEach(function(h){text+=h.textContent+' ';});
  if(navigator.clipboard)navigator.clipboard.writeText(text.trim()).catch(function(){});
  var btn=document.getElementById('copyBtn');
  var lbl=document.getElementById('copyBtnText');
  if(btn)btn.classList.add('copied');
  if(lbl){var orig=lbl.textContent;lbl.textContent='✓ Copied!';setTimeout(function(){if(btn)btn.classList.remove('copied');lbl.textContent=orig;},2200);}
}

var tabContent={
  story:{caption:captions[0],tags:['#UrbanTrendBeauty','#GlowUp','#SkincareIndia','#LuxuryBeauty','#SkincareTok']},
  post:{caption:'Found my forever beauty store 💛 Urban Trend has completely transformed my skincare in just 4 weeks. No filter, just real results ✨',tags:['#UrbanTrendBeauty','#NoFilter','#SkincareRoutine','#GlassSkin','#IndianBeauty','#SkinFirst']},
  reel:{caption:'POV: You shopped at Urban Trend and now you can\'t stop showing everyone your skin 😭✨ Link in bio for the full routine.',tags:['#UrbanTrend','#SkincareTok','#GlowUp','#BeautyTok','#SkinTransformation','#IndianSkincare']}
};
function switchTab(btn,type){
  document.querySelectorAll('.share-tab').forEach(function(t){t.classList.remove('active');});
  btn.classList.add('active');
  var c=document.getElementById('shareCaption');
  var h=document.getElementById('shareHashtags');
  if(!c||!h)return;
  c.style.opacity='0';h.style.opacity='0';
  setTimeout(function(){
    c.textContent=tabContent[type].caption;
    h.innerHTML=tabContent[type].tags.map(function(t){return'<span class="hash">'+t+'</span>';}).join('');
    c.style.opacity='1';h.style.opacity='1';
  },180);
  [c,h].forEach(function(el){el.style.transition='opacity .18s';});
}

/* ── Intro screen (homepage only) ── */
(function(){
  var intro=document.getElementById('ut-intro');
  if(!intro)return;
  if(sessionStorage.getItem('ut-intro-seen')||localStorage.getItem('ut-intro-done')){
    intro.style.display='none';return;
  }
  var pf=document.getElementById('introParticles');
  if(pf){
    for(var i=0;i<40;i++){
      var p=document.createElement('div');
      p.className='intro-particle';
      p.style.cssText='left:'+Math.random()*100+'%;animation-duration:'+(4+Math.random()*8)+'s;animation-delay:'+(Math.random()*4)+'s;';
      pf.appendChild(p);
    }
  }
  setTimeout(function(){closeIntro();},3000);
})();
function closeIntro(){
  var intro=document.getElementById('ut-intro');
  if(!intro||intro.classList.contains('hide'))return;
  sessionStorage.setItem('ut-intro-seen','1');
  localStorage.setItem('ut-intro-done','1');
  intro.classList.add('hide');
  intro.style.pointerEvents='none';
  intro.addEventListener('animationend',function(){
    intro.style.display='none';
    intro.style.visibility='hidden';
  },{once:true});
  setTimeout(function(){if(intro){intro.style.display='none';intro.style.visibility='hidden';intro.style.pointerEvents='none';}},950);
  _openPromoPopupAfterDelay();
}
function _openPromoPopupAfterDelay(){
  if(localStorage.getItem('ut-popup-dismissed'))return;
  setTimeout(function(){
    var o=document.getElementById('ut-popup-overlay');
    if(o)o.classList.add('open');
  },8000);
}
function closePopup(){
  var o=document.getElementById('ut-popup-overlay');
  if(o)o.classList.remove('open');
  localStorage.setItem('ut-popup-dismissed',Date.now());
}
function submitPopup(){
  var e=document.getElementById('popupEmail');
  if(!e||!e.value.includes('@')){if(e)e.style.borderColor='rgba(226,75,74,.6)';return;}
  e.style.borderColor='';
  var btn=document.querySelector('.popup-submit');
  if(btn){btn.textContent='✓ You\'re In!';btn.style.background='#2A8A4A';btn.style.color='#FAF6F0';}
  localStorage.setItem('ut-popup-dismissed',Date.now());
  if(window._learnq){
    window._learnq.push(['identify',{'$email':e.value}]);
    window._learnq.push(['track','Subscribed via Popup',{source:'promo_popup',email:e.value}]);
  }
  fetch('/contact',{
    method:'POST',
    headers:{'Content-Type':'application/x-www-form-urlencoded'},
    body:'form_type=customer&utf8=✓&contact[email]='+encodeURIComponent(e.value)+'&contact[tags]=newsletter'
  }).catch(function(){});
  setTimeout(closePopup,2200);
}

/* ── Scroll progress bar ── */
window.addEventListener('scroll',function(){
  var h=document.documentElement.scrollHeight-window.innerHeight;
  var bar=document.getElementById('ut-progress');
  if(bar&&h>0)bar.style.width=(window.scrollY/h*100)+'%';
},{passive:true});

/* ── Awards strip ── */
(function(){
  var awards=[
    {icon:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C9A96E" stroke-width="1.5" stroke-linecap="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',name:'PETA Certified',year:'Cruelty-Free &amp; Vegan'},
    {icon:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C9A96E" stroke-width="1.5" stroke-linecap="round"><path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2v-4M9 21H5a2 2 0 0 1-2-2v-4m0 0h18"/></svg>',name:'Dermatologist Tested',year:'Clinically Verified'},
    {icon:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C9A96E" stroke-width="1.5" stroke-linecap="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>',name:'Paraben Free',year:'Clean Beauty Standard'},
    {icon:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C9A96E" stroke-width="1.5" stroke-linecap="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.51"/></svg>',name:'Sustainable Packaging',year:'Eco-Conscious Brand'},
    {icon:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C9A96E" stroke-width="1.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>',name:'Made in India',year:'Supporting Local Brands'},
    {icon:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C9A96E" stroke-width="1.5" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>',name:'100% Authentic',year:'Authorised Distributors Only'},
    {icon:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C9A96E" stroke-width="1.5" stroke-linecap="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',name:'Secure Checkout',year:'256-bit SSL Encrypted'},
    {icon:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C9A96E" stroke-width="1.5" stroke-linecap="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>',name:'Fast Delivery',year:'Pan-India &amp; International'},
    {icon:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C9A96E" stroke-width="1.5" stroke-linecap="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.51"/></svg>',name:'Easy Returns',year:'7-Day Return Policy'}
  ];
  var track=document.getElementById('awardsTrack');
  if(!track)return;
  awards.concat(awards).forEach(function(a){
    var d=document.createElement('div');
    d.className='award-item';
    d.innerHTML='<span class="award-icon">'+a.icon+'</span><div class="award-text"><span class="award-name">'+a.name+'</span><span class="award-year">'+a.year+'</span></div>';
    track.appendChild(d);
  });
})();

/* ── Before/After slider ── */
(function(){
  var slider=document.getElementById('baSlider');
  var clip=document.getElementById('baClip');
  var divider=document.getElementById('baDivider');
  if(!slider)return;
  var dragging=false;
  function setPos(x){
    var rect=slider.getBoundingClientRect();
    var pct=Math.max(5,Math.min(95,(x-rect.left)/rect.width*100));
    if(clip)clip.style.width=pct+'%';
    if(divider)divider.style.left=pct+'%';
  }
  slider.addEventListener('mousedown',function(e){dragging=true;setPos(e.clientX);});
  document.addEventListener('mousemove',function(e){if(dragging)setPos(e.clientX);});
  document.addEventListener('mouseup',function(){dragging=false;});
  slider.addEventListener('touchstart',function(e){dragging=true;setPos(e.touches[0].clientX);},{passive:true});
  slider.addEventListener('touchmove',function(e){if(dragging)setPos(e.touches[0].clientX);},{passive:true});
  slider.addEventListener('touchend',function(){dragging=false;});
})();


/* ── Loyalty tier join (localStorage + Smile.io hook) ── */
function joinTier(btn,tier){
  var orig=btn.textContent;
  btn.textContent='✓ Joined '+tier+'!';
  btn.style.background='rgba(40,130,60,.25)';
  btn.style.color='#7BC87B';
  btn.style.borderColor='rgba(40,130,60,.5)';
  localStorage.setItem('ut-loyalty-tier',tier);
  if(window.Smile){window.Smile.activity('tier_selected',{tier_name:tier});}
  setTimeout(function(){
    btn.textContent=orig;
    btn.style.background='';btn.style.color='';btn.style.borderColor='';
  },2500);
}

/* ── Sustainability counter animation ── */
(function(){
  var nums=document.querySelectorAll('.sustain-num[data-target]');
  var done=false;
  var obs=new IntersectionObserver(function(entries){
    if(done)return;
    entries.forEach(function(e){
      if(e.isIntersecting){
        done=true;obs.disconnect();
        nums.forEach(function(el){
          var target=parseInt(el.dataset.target);
          if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches){
            el.textContent=target>=1000?target.toLocaleString(document.documentElement.lang||'en'):target;
          } else {
            var dur=2000,start=null;
            (function tick(ts){
              if(!start)start=ts;
              var p=Math.min((ts-start)/dur,1);
              var ease=1-Math.pow(1-p,3);
              var val=Math.round(ease*target);
              el.textContent=val>=1000?val.toLocaleString(document.documentElement.lang||'en'):val;
              if(p<1)requestAnimationFrame(tick);
              else el.textContent=target>=1000?target.toLocaleString(document.documentElement.lang||'en'):target;
            })(performance.now());
          }
        });
      }
    });
  },{threshold:.3});
  var sustain=document.getElementById('sustainability');
  if(sustain)obs.observe(sustain);
})();

/* ── Reveal animations (.reveal class) ── */
(function(){
  var obs=new IntersectionObserver(function(en){
    en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vis');obs.unobserve(e.target);}});
  },{threshold:.08});
  document.querySelectorAll('.reveal').forEach(function(el){obs.observe(el);});
})();

/* ── Cookie banner ── */
(function(){
  if(localStorage.getItem('ut-cookie-consent'))return;
  setTimeout(function(){
    var b=document.getElementById('cookieBanner');
    if(b)b.style.transform='translateY(0)';
  },1800);
})();
function cookieAccept(){
  localStorage.setItem('ut-cookie-consent','all');
  var b=document.getElementById('cookieBanner');
  if(b){b.style.transform='translateY(100%)';setTimeout(function(){b.style.display='none';},500);}
  showToast('Preferences saved ✓','success');
}
function cookieDecline(){
  localStorage.setItem('ut-cookie-consent','essential');
  var b=document.getElementById('cookieBanner');
  if(b){b.style.transform='translateY(100%)';setTimeout(function(){b.style.display='none';},500);}
}
function cookieManage(){
  showToast('Cookie preferences panel coming soon','info');
}

/* ── Back to top ── */
window.addEventListener('scroll',function(){
  var btn=document.getElementById('backToTop');
  if(!btn)return;
  if(window.scrollY>400){btn.style.opacity='1';btn.style.pointerEvents='auto';}
  else{btn.style.opacity='0';btn.style.pointerEvents='none';}
},{passive:true});

/* ── Toast (fallback; canonical version is in ut-global.js UT.toast) ── */
function showToast(msg,type){
  if(typeof UT!=='undefined'&&UT.toast){UT.toast(msg,type);return;}
  var c=document.getElementById('toastContainer');
  if(!c)return;
  var t=document.createElement('div');
  var colors={success:'rgba(40,130,60,0.95)',error:'rgba(180,40,40,0.95)',info:'rgba(10,9,8,0.97)'};
  var borders={success:'rgba(120,200,120,0.5)',error:'rgba(226,75,74,0.5)',info:'rgba(201,169,110,0.4)'};
  t.style.cssText='background:'+colors[type||'info']+';border:1px solid '+borders[type||'info']+';padding:12px 20px;font-family:var(--ut-font-serif);font-size:8px;letter-spacing:0.28em;text-transform:uppercase;color:#FAF6F0;pointer-events:auto;opacity:0;transform:translateX(20px);transition:all 0.35s cubic-bezier(0.22,1,0.36,1);backdrop-filter:blur(12px);min-width:220px;cursor:pointer;';
  t.textContent=msg;
  t.onclick=function(){_dismissToast(t);};
  c.appendChild(t);
  requestAnimationFrame(function(){t.style.opacity='1';t.style.transform='translateX(0)';});
  setTimeout(function(){_dismissToast(t);},3800);
}
function _dismissToast(t){
  t.style.opacity='0';t.style.transform='translateX(20px)';
  setTimeout(function(){if(t.parentNode)t.parentNode.removeChild(t);},350);
}

/* ── Sticky ATC on PDP overlay ── */
(function(){
  var atc=document.getElementById('stickyATC');
  var overlay=document.getElementById('pageOverlay');
  if(!atc||!overlay)return;
  function checkAtc(){
    var pdp=document.getElementById('page-pdp');
    var pdpVisible=overlay.classList.contains('visible')&&pdp&&pdp.style.display!=='none';
    atc.style.bottom=(pdpVisible&&overlay.scrollTop>320)?'0':'-80px';
  }
  overlay.addEventListener('scroll',checkAtc,{passive:true});
  var origShow=window.showPage;
  window.showPage=function(n){if(origShow)origShow(n);setTimeout(checkAtc,50);};
  var origHide=window.hidePage;
  window.hidePage=function(){if(origHide)origHide();if(atc)atc.style.bottom='-80px';};
})();

/* ── Size guide modal ── */
function openSizeGuide(){
  var m=document.getElementById('sizeGuideModal');
  if(m){m.style.display='flex';document.body.style.overflow='hidden';}
}
function closeSizeGuide(){
  var m=document.getElementById('sizeGuideModal');
  if(m){m.style.display='none';document.body.style.overflow='';}
}

/* ── Pincode delivery check ── */
var pincodeData={
  '125055':{city:'Sirsa, Haryana',days:0,express:true},
  '125001':{city:'Hisar, Haryana',days:1,express:true},
  '110001':{city:'New Delhi',days:2,express:true},
  '110002':{city:'New Delhi',days:2,express:true},
  '110003':{city:'New Delhi',days:2,express:true},
  '110011':{city:'New Delhi',days:2,express:true},
  '110020':{city:'New Delhi',days:2,express:true},
  '560001':{city:'Bengaluru',days:3,express:false},
  '560002':{city:'Bengaluru',days:3,express:false},
  '560034':{city:'Bengaluru',days:3,express:false},
  '560078':{city:'Bengaluru',days:3,express:false},
  '400001':{city:'Mumbai',days:3,express:false},
  '400002':{city:'Mumbai',days:3,express:false},
  '400050':{city:'Mumbai',days:3,express:false},
  '400068':{city:'Mumbai',days:3,express:false},
  '700001':{city:'Kolkata',days:4,express:false},
  '700013':{city:'Kolkata',days:4,express:false},
  '600001':{city:'Chennai',days:4,express:false},
  '600020':{city:'Chennai',days:4,express:false},
  '500001':{city:'Hyderabad',days:4,express:false},
  '500034':{city:'Hyderabad',days:4,express:false},
  '411001':{city:'Pune',days:3,express:false},
  '411014':{city:'Pune',days:3,express:false},
  '380001':{city:'Ahmedabad',days:3,express:false},
  '302001':{city:'Jaipur',days:3,express:false},
  '226001':{city:'Lucknow',days:3,express:false},
  '160017':{city:'Chandigarh',days:2,express:true},
  '201301':{city:'Noida',days:2,express:true},
  '122001':{city:'Gurgaon',days:2,express:true}
};
function checkPincode(){
  var inp=document.getElementById('pincodeInput');
  var res=document.getElementById('pincodeResult');
  if(!inp||!res)return;
  var val=inp.value.trim().replace(/\D/g,'');
  inp.value=val;
  if(val.length!==6){
    res.style.display='block';
    res.innerHTML='<span style="color:rgba(226,75,74,0.8);">Please enter a valid 6-digit PIN code.</span>';
    return;
  }
  res.style.display='block';
  var data=pincodeData[val];
  if(data){
    var badge=(data.days<=1)?'<span style="background:rgba(40,130,60,0.2);color:#7BC87B;border:1px solid rgba(120,200,120,0.3);padding:2px 8px;font-family:var(--ut-font-serif);font-size:6px;letter-spacing:0.28em;text-transform:uppercase;margin-left:8px;">'+(data.days===0?'Same Day':'Next Day')+'</span>':'';
    var daysText=data.days===0?'Expected today':data.days===1?'Expected tomorrow':'Expected in '+data.days+' days';
    res.innerHTML='<span style="color:#7BC87B;">✓ Delivery available to '+data.city+'</span><br>'+daysText+badge+(data.express?'<br><span style="color:rgba(201,169,110,0.6);">Express delivery available</span>':'');
  } else {
    res.innerHTML='<span style="color:#C9A96E;">✓ Delivery available to your area — expected in 4–6 business days.</span>';
  }
}
document.addEventListener('DOMContentLoaded',function(){
  var inp=document.getElementById('pincodeInput');
  if(inp){
    inp.addEventListener('keydown',function(e){if(e.key==='Enter')checkPincode();});
    inp.addEventListener('input',function(){this.value=this.value.replace(/\D/g,'').slice(0,6);});
  }
});

/* ── Gift wrap toggle — writes to cart note as a property ── */
var giftWrapEnabled=false;
function toggleGiftWrap(row){
  giftWrapEnabled=!giftWrapEnabled;
  var check=document.getElementById('giftWrapCheck');
  if(check)check.textContent=giftWrapEnabled?'✓':'';
  row.style.borderColor=giftWrapEnabled?'rgba(201,169,110,0.4)':'rgba(201,169,110,0.12)';
  row.style.background=giftWrapEnabled?'rgba(201,169,110,0.06)':'';
  var _gtCurr=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'INR';
  var _gtPrice=_gtCurr==='INR'?'₹149':'$1.99';
  /* Write gift wrap preference to cart attributes so it persists to checkout */
  fetch('/cart/update.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({attributes:{'Gift Wrap':giftWrapEnabled?'Yes ('+_gtPrice+')':'No'}})
  }).catch(function(){});
  showToast(giftWrapEnabled?'🎁 Gift wrapping added — '+_gtPrice:'Gift wrapping removed',giftWrapEnabled?'success':'info');
}

/* ── Order tracking ── */
function utTrackOrder(){
  var inp=document.getElementById('trackingInput');
  var res=document.getElementById('trackingResult');
  var link=document.getElementById('utTrackLink');
  if(!inp||!res)return;
  var val=inp.value.trim();
  if(!val){inp.style.borderColor='rgba(226,75,74,0.5)';inp.focus();return;}
  inp.style.borderColor='';
  var btn=inp.nextElementSibling;
  if(btn){btn.textContent='Looking up…';btn.disabled=true;}
  if(link){
    link.href='/account/orders';
    link.textContent='View My Orders →';
  }
  setTimeout(function(){
    res.style.display='block';
    res.style.opacity='0';
    setTimeout(function(){res.style.transition='opacity 0.4s';res.style.opacity='1';},30);
    if(btn){btn.textContent='Track →';btn.disabled=false;}
    res.scrollIntoView({behavior:'smooth',block:'start'});
  },600);
}
function trackOrder(){utTrackOrder();}

/* ── FIX #8: subscribeNewsletter — canonical version.
      ut-global.js window.subscribeNewsletter is defined after DOMContentLoaded
      so this definition (which runs at parse time) will be overridden by the
      more complete one in ut-global.js. Both implementations are equivalent
      but this guards against race conditions when UT isn't yet loaded. ── */
if(typeof window.subscribeNewsletter==='undefined'){
  window.subscribeNewsletter=function(){
    var inputs=document.querySelectorAll('.nl-input,.nl-email-input,#nlEmailInput');
    var inp=null;
    inputs.forEach(function(el){if(el.value.trim())inp=el;});
    if(!inp)inp=inputs[0];
    if(!inp)return;
    var v=inp.value.trim();
    if(!v||!v.includes('@')){inp.style.borderColor='rgba(226,75,74,0.5)';inp.focus();return;}
    inp.style.borderColor='';
    var btn=inp.nextElementSibling;
    if(btn){btn.textContent='Subscribing…';btn.disabled=true;}
    var body='form_type=customer&utf8=✓&customer[email]='+encodeURIComponent(v)+'&customer[tags]=newsletter&contact[accepts_marketing]=true';
    fetch('/contact#contact_form',{
      method:'POST',
      headers:{'Content-Type':'application/x-www-form-urlencoded','X-Requested-With':'XMLHttpRequest'},
      body:body
    }).then(function(){
      inp.value='';inp.placeholder='You\'re on the Glow List! ✓';inp.style.color='#7BC87B';inp.style.borderColor='rgba(120,200,120,0.4)';
      if(btn){btn.textContent='✓';}
      showToast('✓ Welcome to the Glow List! Check your inbox.','success');
      localStorage.setItem('ut-newsletter','1');
      setTimeout(function(){inp.placeholder='your@email.com';inp.style.color='';inp.style.borderColor='';if(btn){btn.textContent='Subscribe →';btn.disabled=false;}},3500);
    }).catch(function(){
      if(btn){btn.textContent='Subscribe →';btn.disabled=false;}
      showToast('Something went wrong — please try again.','error');
    });
  };
}

/* ── Review bar animation ── */
(function(){
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        document.querySelectorAll('#revBars .rev-bar-fill').forEach(function(f){f.style.width=f.dataset.w+'%';});
        obs.disconnect();
      }
    });
  },{threshold:0.3});
  var revSection=document.querySelector('.pdp-reviews');
  if(revSection)obs.observe(revSection);
})();

/* ── Review filter ── */
function filterRevs(btn,type){
  document.querySelectorAll('.rev-filter-btn').forEach(function(b){
    b.style.background='none';b.style.borderColor='rgba(201,169,110,0.15)';b.style.color='rgba(201,169,110,0.5)';
  });
  btn.style.background='rgba(201,169,110,0.08)';btn.style.borderColor='rgba(201,169,110,0.35)';btn.style.color='#C9A96E';
  document.querySelectorAll('.review-card').forEach(function(c){
    if(type==='all')c.style.display='';
    else if(type==='5')c.style.display=c.dataset.stars==='5'?'':'none';
    else if(type==='photos')c.style.display=c.dataset.photos==='true'?'':'none';
  });
}
function loadMoreReviews(btn){
  btn.textContent='Loading…';
  setTimeout(function(){
    btn.textContent='No more reviews to show';
    btn.disabled=true;
    btn.style.opacity='0.4';
  },800);
}
function openWriteReview(){
  showToast('Review form — connect Judge.me or Okendo in Shopify Admin to enable','info');
}

/* ── Mobile nav ── */
function openMobileNav(){
  document.getElementById('mobileNav')&&document.getElementById('mobileNav').classList.add('open');
  document.getElementById('mobileNavOverlay')&&document.getElementById('mobileNavOverlay').classList.add('open');
  document.body.style.overflow='hidden';
}
function closeMobileNav(){
  document.getElementById('mobileNav')&&document.getElementById('mobileNav').classList.remove('open');
  document.getElementById('mobileNavOverlay')&&document.getElementById('mobileNavOverlay').classList.remove('open');
  document.body.style.overflow='';
}

/* ── Product detail modal (homepage cards) ── */
var _pdProducts={
  'Vitamin C Brightening Serum':{cat:'Skincare',sub:'Top Vitamin C brands',price:'From ₹ 299',desc:'Urban Trend carries India\'s top-rated Vitamin C serums from O3+, WOW, Mamaearth and more. 100% authentic, sourced directly from brands.',benefits:['100% Authentic','Best Indian brands','Fades dark spots','Direct from distributors']},
  'Face Masks':{cat:'Skincare',sub:'Multi-brand',price:'From ₹ 199',desc:'Urban Trend stocks India\'s best face masks — clay, saffron, charcoal, hydrating. 100% authentic from top Indian brands.',benefits:['100% Authentic','Best Indian brands','For all skin types','Direct from distributors']},
  'Foundation':{cat:'Makeup',sub:'Top Indian brands',price:'From ₹ 299',desc:'Urban Trend carries the best Indian foundations from Lakme, L\'Oreal, Faces Canada and more. Perfect shades for Indian skin tones.',benefits:['100% Authentic','Best Indian brands','Indian skin shades','Direct from distributors']},
  'Fragrance':{cat:'Fragrance',sub:'Top Indian brands',price:'From ₹ 299',desc:'Urban Trend stocks India\'s best fragrances — oud, floral, fresh and woody. 100% authentic from top brands.',benefits:['100% Authentic','Long-lasting','Best Indian brands','Direct from distributors']},
  'Eye Cream':{cat:'Skincare',sub:'Top eye care brands',price:'From ₹ 199',desc:'Urban Trend stocks top-rated eye creams from India\'s best brands — for dark circles, puffiness and fine lines.',benefits:['100% Authentic','Dermatologist recommended','For dark circles','Direct from distributors']},
  'Highlighter':{cat:'Makeup',sub:'Top glow brands',price:'From ₹ 299',desc:'Urban Trend carries India\'s best highlighters and glow products from top brands. Handpicked for Indian complexions.',benefits:['100% Authentic','Best Indian brands','For all skin tones','Direct from distributors']},
  'Toner':{cat:'Skincare',sub:'Top toner brands',price:'From ₹ 199',desc:'Urban Trend stocks top-rated toners from WOW, Mamaearth, O3+ and more. Balances pH, tightens pores.',benefits:['100% Authentic','Best Indian brands','pH balancing','For all skin types']},
  'Saffron Hair Oil':{cat:'Hair',sub:'100ml · Strengthening',price:'₹ 1,299',desc:'Luxurious hair oil with pure saffron, coconut, and argan. Reduces breakage, adds shine, and promotes growth.',benefits:['Pure Kashmiri saffron','Reduces hair fall','Overnight repair mask','Suitable all hair types']}
};
function openPD(name){
  var p=_pdProducts[name]||{cat:'Beauty',sub:'Authentic Indian brand',price:'From ₹ 299',desc:'Authentic Indian beauty product, hand-picked by Urban Trend.',benefits:['100% Authentic','Best Indian brands','Dermatologist recommended','Direct from distributors']};
  document.getElementById('pdCat')&&(document.getElementById('pdCat').textContent=p.cat);
  document.getElementById('pdName')&&(document.getElementById('pdName').textContent=name);
  document.getElementById('pdSub')&&(document.getElementById('pdSub').textContent=p.sub);
  document.getElementById('pdPrice')&&(document.getElementById('pdPrice').textContent=p.price);
  document.getElementById('pdDesc')&&(document.getElementById('pdDesc').textContent=p.desc);
  if(document.getElementById('pdBenefits')){
    document.getElementById('pdBenefits').innerHTML=p.benefits.map(function(b){
      return'<div style="display:flex;align-items:center;gap:8px;"><span style="color:#C9A96E;font-size:12px;">✓</span><span style="font-family:var(--ut-font-body);font-size:12px;color:rgba(250,246,240,0.75);">'+b+'</span></div>';
    }).join('');
  }
  if(document.getElementById('pdImg')){
    document.getElementById('pdImg').innerHTML='<div style="text-align:center;"><div style="width:180px;height:220px;background:linear-gradient(145deg,#2A1A0E,#1A1008);border:1px solid rgba(201,169,110,0.2);display:flex;align-items:center;justify-content:center;margin:0 auto;"><span style="font-family:var(--ut-font-serif);font-size:13px;color:#C9A96E;letter-spacing:0.2em;text-transform:uppercase;text-align:center;padding:20px;">'+name+'</span></div><p style="font-family:var(--ut-font-serif);font-size:8px;color:rgba(201,169,110,0.5);letter-spacing:0.3em;margin-top:16px;text-transform:uppercase;">Urban Trend</p></div>';
  }
  _pdCurrentQty=1;
  document.getElementById('pdQty')&&(document.getElementById('pdQty').textContent=1);
  var modal=document.getElementById('pdModal');
  if(modal){modal.style.display='block';document.body.style.overflow='hidden';}
}
function closePD(){
  var modal=document.getElementById('pdModal');
  if(modal){modal.style.display='none';document.body.style.overflow='';}
}
document.addEventListener('DOMContentLoaded',function(){
  var modal=document.getElementById('pdModal');
  if(modal){modal.addEventListener('click',function(e){if(e.target===this)closePD();});}
  /* Product card overlay button — keep overlay label only, do NOT intercept card nav */
  document.querySelectorAll('.pcard').forEach(function(card){
    var btn=card.querySelector('.pcard-overlay-btn');
    if(btn){
      btn.textContent='View Product';
      /* Overlay button navigates to the card's href */
      btn.addEventListener('click',function(e){
        e.stopPropagation();
        var href=card.getAttribute('href');
        if(href)window.location.href=href;
      });
    }
  });
});

/* ─────────────────────────────────────────────────────────────
   WISHLIST ENGINE — localStorage
   ───────────────────────────────────────────────────────────── */
var UT_WISH_KEY='ut-wishlist-v1';
function utWishLoad(){try{return JSON.parse(localStorage.getItem(UT_WISH_KEY))||[];}catch(e){return[];}}
function utWishSave(items){try{localStorage.setItem(UT_WISH_KEY,JSON.stringify(items));}catch(e){}}
function utWishCount(){
  var n=utWishLoad().length;
  var badge=document.getElementById('utWishCount');
  if(badge)badge.textContent=n>0?'('+n+' saved)':'';
  var navBadge=document.getElementById('wishBadge');
  if(navBadge)navBadge.textContent=n>0?n:'';
}
function utWishRender(){
  var items=utWishLoad();
  var grid=document.getElementById('utWishGrid');
  var empty=document.getElementById('utWishEmpty');
  if(!grid)return;
  grid.innerHTML='';
  if(items.length===0){if(empty)empty.style.display='block';return;}
  if(empty)empty.style.display='none';
  items.forEach(function(p,i){
    var imgHtml=p.image
      ?'<img src="'+p.image+'" alt="'+(p.title||'').replace(/"/g,'&quot;')+'" width="80" height="80" loading="lazy" style="width:80px;height:80px;object-fit:cover;border-radius:2px;">'
      :'<span style="font-size:36px;color:#C9A96E;" aria-hidden="true">✦</span>';
    var card=document.createElement('div');
    card.className='wl-card';
    card.dataset.handle=p.handle||'';
    card.innerHTML=''
      +'<button class="wl-heart" onclick="utWishRemove(\''+(p.handle||i)+'\',this)" aria-label="Remove from wishlist">♥</button>'
      +'<a href="'+(p.url||'/products/'+p.handle)+'" class="wl-img" style="display:block;text-decoration:none;">'+imgHtml+'</a>'
      +'<div class="wl-name"><a href="'+(p.url||'/products/'+p.handle)+'" style="color:inherit;text-decoration:none;">'+(p.title||'Product')+'</a></div>'
      +'<div class="wl-price">'+(p.price||'')+'</div>'
      +'<button class="wl-add" data-variant-id="'+(p.variantId||'')+'" onclick="addToCartFromWishlist(this)">Add to Bag</button>';
    grid.appendChild(card);
  });
  utWishCount();
}
function utWishAdd(product){
  var items=utWishLoad();
  if(!items.some(function(p){return p.handle===product.handle;})){
    items.push(product);utWishSave(items);
  }
  utWishCount();
  showToast('Added to wishlist ♥','success');
}
function utWishRemove(handle,btn){
  var items=utWishLoad().filter(function(p){return p.handle!==handle;});
  utWishSave(items);
  if(btn){
    var card=btn.closest('.wl-card');
    if(card){card.style.opacity='0';card.style.transition='opacity 0.3s';setTimeout(function(){card.remove();utWishRender();},320);}
  } else {
    utWishRender();
  }
  utWishCount();
}
function utWishToggle(handle,title,price,image,url,variantId){
  var items=utWishLoad();
  var idx=-1;
  items.forEach(function(p,i){if(p.handle===handle)idx=i;});
  if(idx>-1){
    items.splice(idx,1);utWishSave(items);utWishCount();
    showToast('Removed from wishlist','info');
    return false;
  } else {
    utWishAdd({handle:handle,title:title,price:price,image:image,url:url,variantId:variantId});
    return true;
  }
}

/* FIX #4: removeWishlist — only the engine alias, early stub removed */
function removeWishlist(btn){
  var card=btn.closest('.wl-card');
  var handle=card?card.dataset.handle:null;
  if(handle)utWishRemove(handle,btn);
  else if(card){card.style.opacity='0';setTimeout(function(){card.remove();},300);}
}

/* Intercept showPage to render wishlist when opened */
var _utOrigShowPage=window.showPage;
window.showPage=function(name){
  if(_utOrigShowPage)_utOrigShowPage(name);
  if(name==='wishlist')utWishRender();
};
document.addEventListener('DOMContentLoaded',function(){utWishCount();});
